import React from "react";

import SupportPageLayout from "./SupportPageLayout";
import RxAccordion from "@/components/ui/display/RxAccordion";

const faqItems = [
  // {
  //   title: "I can't find the Digital App on my phone",
  //   content: "Please note that our Digital App is currently not available on android. Please follow this link – ADD LINK - WEBPAGE.",
  // },
  {
    title: "I can't log into my Digital account",
    content: (
      <>
        If you are having issues logging in please contact us at{" "}
        <a href="mailto:digital@allbright.co">digital@allbright.co</a>. Please
        make sure to do this from the email address currently linked to your
        account.
      </>
    ),
  },
  {
    title: "I want to change my email address on my Digital account",
    content: (
      <>
        To update your email address contact us at{" "}
        <a href="mailto:digital@allbright.co">digital@allbright.co</a>. Please
        make sure to do this from the email address currently linked to your
        account.
      </>
    ),
  },
  {
    title: "My iOS app looks different to the website",
    content: (
      <>
        We are currently making great improvements to our Digital platform; for
        now please continue to use AllBright in your browser on desktop, tablet,
        or mobile while our native apps are updated in due course.
      </>
    ),
  },
  {
    title: "I am a Digital Member, and I can't buy a ticket to an event",
    content: (
      <>
        Most of our events are available online, but some in-person events are
        only available to Mayfair Club members. Please check what type of event
        you are looking to attend.
      </>
    ),
  },
  {
    title: "I have a question about Mentor Matching",
    content: (
      <>
        If you have any questions about our Mentor Matching feature please take
        a look at our Mentor Matching FAQs{" "}
        <a href="https://www.allbrightcollective.com/edit/articles/mentor-matching-everything-you-need-to-know">
          here
        </a>
        .
      </>
    ),
  },
  {
    title: "I want to cancel my Digital Membership",
    content: (
      <>
        You can cancel your membership through your profile{" "}
        <a href="https://www.allbrightcollective.com/account?membership">
          here
        </a>
        , after which you will retain your membership until the end of the
        current billing period.
      </>
    ),
  },
];

const SupportVirtual: React.FC = (): JSX.Element => {
  return (
    <SupportPageLayout>
      <RxAccordion items={faqItems} />
    </SupportPageLayout>
  );
};

export default SupportVirtual;
